import { ref, type Ref } from 'vue';
import type { SiteConfigDto } from '@s-blog/shared-types';
import { siteConfigApi } from '@/api/public';

// 单例：站点配置在全站任何角落都可读，只在 App.vue 启动时拉一次
const config = ref<SiteConfigDto | null>(null);
const loading = ref(false);
const error = ref<string | null>(null);

let inflight: Promise<void> | null = null;

async function load(force = false): Promise<void> {
  if (config.value && !force) return;
  if (inflight) return inflight;
  loading.value = true;
  error.value = null;
  inflight = siteConfigApi
    .get()
    .then((dto) => {
      config.value = dto;
    })
    .catch((e: unknown) => {
      error.value = e instanceof Error ? e.message : '站点配置加载失败';
    })
    .finally(() => {
      loading.value = false;
      inflight = null;
    });
  return inflight;
}

export function useSiteConfig(): {
  config: Ref<SiteConfigDto | null>;
  loading: Ref<boolean>;
  error: Ref<string | null>;
  load: (force?: boolean) => Promise<void>;
} {
  return { config, loading, error, load };
}
